import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import Select, { useStateManager } from "react-select"
import CountUp from 'react-countup';
import { FaRegFileAlt } from 'react-icons/fa';
import { FiPlusSquare } from "react-icons/fi";
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import "../../assets/css/inventorymanagement.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import bulkEditCsv from "./../../assets/json/bulkedit.csv";
import { FilePlus, ArrowUpCircle ,Download,Eye  } from "lucide-react";
import { saveAs } from "file-saver";
import "./datepicker.css"

const todayIST = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const IndentationCreation = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [originalrowData, setoriginalrowData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [currentSkuCode, setCurrentSkuCode] = useState("")
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState("")
  const [currentUploadedDate, setCurrentUploadedDate] = useState("")
  const [prevDate, setPrevDate] = useState("");
  const [storeId, setStoreId] = useState();
  const [prevStoreId, setPrevStoreId] = useState(null);
  const [storeOptions, setStoreOptions] = useState([]);
  const [skuCode, setSkuCode] = useState(null);
  const [skuOptions, setSkuOptions] = useState([]);
  const [latestDDDate, setlatestDDDate] = useState(todayIST())
  const [createIndentDate, setCreateIndentDate] = useState(latestDDDate);
  const [isCreatingIndent, setIsCreatingIndent] = useState(false);
  const [filename, setFilename]  = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [isDownloading, setIsDownloading] = useState(false);
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [isBatchModalOpen, setBatchModalOpen] = useState(false);
  const [batchData, setBatchData] = useState([]);
  const [selectedSkuInfo, setSelectedSkuInfo] = useState(null);

  const gridRef = useRef(); 
  const batchGridRef = useRef();

  const [editFormData, setEditFormData] = useState({
    final_indent_quantity: "",
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    final_indent_quantity: "",
  });
  const [editingRow, setEditingRow] = useState(null);

  // Column definitions for batch data modal
  const batchColumnDefs = [
    {
      headerName: "Batch Number",
      field: "batch",
      sortable: true,
      filter: true,
      width: 150,
    },
    {
      headerName: "Stock Quantity",
      field: "stock",
      sortable: true,
      filter: true,
      width: 150,
      valueFormatter: (params) => {
        if (params.value === undefined || params.value === null) return "-";
        return params.value;
      }
    },
    {
      headerName: "SKU Code",
      field: "sku_code",
      sortable: true,
      filter: true,
      width: 150,
      hide: true 
    },
    {
      headerName: "Store ID",
      field: "store_id",
      sortable: true,
      filter: true,
      width: 150,
      hide: true
    }
  ];

  const columnWithDefs = [
    {
      headerName: "",
      field: "multi_select",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      width: 50,
    },
    { headerName: "Destination Store ID", field: "destination_store_id" },
    { headerName: "Destination Store Name", field: "destination_store_name" },
    {
      headerName: "Destination Type",
      field: "destination_type",
      valueGetter: (params) =>
        params.data.destination_type === "darkstore" ? "DarkStore" : params.data.destination_type === "warehouse" ? "Warehouse" : "Unknown"
    },
    { headerName: "Source Name", field: "plant_name" },
    { headerName: "Source ID", field: "plant_id" },
    { headerName: "SKU Code (Dark Store)", field: "f_code" },
    { headerName: "SKU Code", field: "sku_code" },
    { headerName: "SKU Name", field: "sku_name" },
    { headerName: "SKU Category", field: "sku_category" },
    {
      headerName: "Indent Cycle Date",
      field: "cycle_date",
      valueGetter: (params) => params.data.cycle_date
        ? new Date(params.data.cycle_date).toISOString().split("T")[0]
        : ""
    },
    {
      headerName: "Indent Created Date",
      field: "date",
      valueGetter: (params) => params.data.date
        ? new Date(params.data.date).toISOString().split("T")[0]
        : ""
    },
    {
      headerName: "Original Indent Stock",
      field: "indent_stock",
    },
    { headerName: "PO Stock", field: "po_stock" },
    { headerName: "Indent After PO", field: "indent_after_po" },
    { headerName: "Case Size", field: "case_size" },
    { headerName: "Case Adjustment Stock", field: "case_adjustment_stock" },
    { headerName: "Indent Cases", field: "indent_cases" },
    {
      headerName: "System Indent Stock",
      field: "old_indent_stock",
      valueGetter: (params) => params.data.old_final_indent_quantity || "-"
    },
    { headerName: "Final Indent Stock", field: "final_indent_quantity" },
    {
      headerName: "Batches",
      field: "actions",
      sortable: false,
      filter: false,
      width: "180px",
      cellClass: "custom-cell",
      cellRendererFramework: (params) => (
        <div style={{ height: "36px", padding: 0, display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
          <button
            title="View Batches"
            className="mt-2"
            style={{
              height: "30px",
              width: "60px",
              padding: "0 10px",
              border: "1px solid #93385D",
              borderRadius: "4px",
              cursor: "pointer",
              backgroundColor: "#F4EBEF",
              fontSize: "0.8rem",
              color: "#93385D",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px"
            }}
            onClick={() => handleViewBatches(params.data)}
          >
            View
          </button>
        </div>
      ),
    },
    {
      headerName: "",
      field: "actions",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell",
      cellRendererFramework: (params) => (
        <div style={{ height: "36px", padding: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <button
            title="Edit"
            className="mt-2"
            style={{
              height: "30px",
              width: "60px",
              padding: "0 10px",
              border: "1px solid #93385D",
              borderRadius: "4px",
              cursor: "pointer",
              backgroundColor: "#F4EBEF",
              fontSize: "0.8rem",
              color: "#93385D"
            }}
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
        </div>
      ),
    },
  ];

  const getHighlightedDates = async () => {  
    try {
      const response = await redirectURL.post("indentation/getDSCurrentStockdates", {});
      if (response.status === 200 && response.data.dates) {
        const dates = response.data.dates.map(dateStr => {
          try {
            return new Date(dateStr);
          } catch (e) {
            return null;
          }
        }).filter(date => date !== null);
        setHighlightedDates(dates);
      }
    } catch (error) {
      console.error("Failed to fetch highlighted dates:", error);
    }
  }

  const handleViewBatches = (rowData) => {
    let batches = [];
    if (rowData.batch_data) {
      if (typeof rowData.batch_data === 'string') {
        try {
          batches = JSON.parse(rowData.batch_data);
        } catch (e) {
          console.error("Error parsing batch data:", e);
          batches = [];
        }
      } else if (Array.isArray(rowData.batch_data)) {
        batches = rowData.batch_data;
      }
    }

    const batchesWithInfo = batches.map(batch => ({
      ...batch,
      sku_code: rowData.sku_code,
      sku_name: rowData.sku_name,
      store_id: rowData.destination_store_id,
      store_name: rowData.destination_store_name,
      source_id: rowData.plant_id,
      source_name: rowData.plant_name
    }));

    setBatchData(batchesWithInfo);
    setSelectedSkuInfo({
      sku_code: rowData.sku_code,
      sku_name: rowData.sku_name,
      store_id: rowData.destination_store_id,
      store_name: rowData.destination_store_name,
      total_stock: rowData.final_indent_quantity,
      source_id: rowData.plant_id,
      source_name: rowData.plant_name
    });
    setBatchModalOpen(true);
  };

  // ============= DOWNLOAD FUNCTION - EXACTLY LIKE DOWNLOADWAREHOUSEINDENTSDATA =============
  const downloadExcel = async () => {
    if (!currentinvoiceDate) {
      setShow(true);
      setBasicTitle("Please select a date to download data");
      setBasicType("info");
      return;
    }

    setIsDownloading(true);
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const payload = { date: currentinvoiceDate };
      if (storeId?.value && storeId.value !== "") {
        payload.destination_store_id = storeId.value;
      }

      const response = await redirectURL.post(
        "indentation/downloadIndentsData",
        payload
      );

      if (response.data.status === "success") {
        const jsonData = response.data.response?.message;
        const parsedData = JSON.parse(jsonData);

        if (!parsedData.length) {
          setShow(true);
          setBasicTitle("No data available for the selected date");
          setBasicType("info");
          return;
        }

        // // Format headers and values
        // const formattedData = parsedData.map(row => {
        //   const formattedRow = {};
        //   Object.entries(row).forEach(([key, value]) => {
        //     const formattedKey = key
        //       .split("_")
        //       .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        //       .join(" ");

        //     let formattedValue = value;
        //     if (typeof value === "string" && value.includes("T")) {
        //       formattedValue = value.split("T")[0];
        //     }

        //     formattedRow[formattedKey] = formattedValue;
        //   });
        //   return formattedRow;
        // });


        // Replace your existing formattedData block with this:
        const formattedData = parsedData.map((row) => {
          const formattedRow = {};

          Object.entries(row).forEach(([key, value]) => {
            // Handle batch_data separately
            if (key === "batch_data") {
              let batchArray = [];

              // If batch_data comes as string, parse it
              if (typeof value === "string") {
                try {
                  // Convert Python-style single quotes to JSON double quotes
                  const cleanedValue = value
                    .replace(/datetime\.datetime\([^)]*\)/g, 'null')
                    .replace(/'/g, '"');

                  batchArray = JSON.parse(cleanedValue);
                } catch (err) {
                  batchArray = [];
                }
              } else if (Array.isArray(value)) {
                batchArray = value;
              }

              // Flatten batch array into separate columns
              batchArray.forEach((batch) => {

                formattedRow[`Batch`] = batch.batch || "";
                formattedRow[`Stock`] = batch.stock ?? "";

              });
            } else {
              // Normal fields
              const formattedKey = key
                .split("_")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" ");

              let formattedValue = value;

              // Format ISO date strings
              if (typeof value === "string" && value.includes("T")) {
                formattedValue = value.split("T")[0];
              }

              // Skip original batch_data field
              if (key !== "batch_data") {
                formattedRow[formattedKey] = formattedValue;
              }
            }
          });

          return formattedRow;
        });

        // Create worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Darkstore_Indents");

        // Generate filename
        let fileName = `darkstore_indents_${currentinvoiceDate}`;
        if (storeId?.value && storeId.value !== "") {
          fileName += `_${storeId.value}`;
        }
        fileName += `.xlsx`;

        // Write Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, fileName);

        setShow(true);
        setBasicTitle("Data downloaded successfully");
        setBasicType("success");

        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Downloaded Indentation Data",
          status: "Success",
          path: window.location.pathname
        });
      } else {
        setShow(true);
        setBasicTitle("No data available for the selected date");
        setBasicType("info");
      }
    } catch (err) {
      console.error("Download error:", err);
      setShow(true);
      setBasicTitle("Failed to download Indent data");
      setBasicType("error");

      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Downloaded Indentation Data",
        status: "Error",
        path: window.location.pathname
      });
    } finally {
      setIsDownloading(false);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const resetFormData = () => {
    setEditFormData({
      final_indent_quantity: "",
    });
    setDuplicatedEditData({
      final_indent_quantity: "",
    });
    setEditingRow(null);
  };

  const handleEdit = (rowData) => {
    setEditingRow(rowData);

    const currentValue = rowData.final_indent_quantity || "";

    setEditFormData({
      final_indent_quantity: currentValue,
    });
    setDuplicatedEditData({
      final_indent_quantity: currentValue,
    });

    setSliderType(3);
    setSliderTitle(`Edit Final Indent Quantity - ${rowData.sku_code}`);
    setSliderCl("edit-indent-slider");
    setOverlyBlock("show-m");
    setSliderOpen(true);
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();

    const newValue = parseInt(editFormData.final_indent_quantity);
    const oldValue = parseInt(duplicatedEditData.final_indent_quantity);

    if (editFormData.final_indent_quantity === "" || newValue === oldValue) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please enter a new value or the value is same as current");
      return;
    }

    if (isNaN(newValue) || newValue < 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please enter a valid positive number");
      return;
    }

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const oldFinalIndentQuantity = editingRow.old_final_indent_quantity || editingRow.final_indent_quantity;

      const response = await redirectURL.post("indentation/updateFinalIndentQuantity", {
        id: editingRow.id,
        destination_store_id: editingRow.destination_store_id,
        sku_code: editingRow.sku_code,
        date: editingRow.date,
        current_final_indent_quantity: editingRow.final_indent_quantity,
        new_final_indent_quantity: newValue,
        cycle_date: editingRow.cycle_date
      });

      if (response.data.status === "success") {
        const updatedData = rowData.map(item =>
          item.id === editingRow.id
            ? {
                ...item,
                final_indent_quantity: newValue,
              }
            : item
        );

        setRowData(updatedData);
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Final indent quantity updated successfully");

        setSliderOpen(false);
        setOverlyBlock("show-n");
        resetFormData();

        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Final Indent Quantity Edited",
          status: "Success",
          path: window.location.pathname
        });
      } else {
        throw new Error(response.data.message || "Update failed");
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("error");
      setBasicTitle("Failed to update final indent quantity");
      console.error("Error updating final indent quantity:", error);

      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Final Indent Quantity Edited",
        status: "Failure",
        path: window.location.pathname
      });
    }
  };

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  }

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("")
    setUploadedFileData([]);
    resetFormData();
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getSkuMasterData = async () => {
    try {
      const response = await redirectURL.post("indentation/getIndentationCreationsData", {})

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const responseData = response.data.data

          const { date, status, destinations, latest_dd_date } = response.data
          const destinationOptions = destinations.map(item => ({ value: item.destination_store_id, label: `${item.destination_store_id} - ${item.destination_store_name}` }))
          destinationOptions.unshift({ value: "", label: "ALL" })
          const ddformattedDate = latest_dd_date ? new Date(latest_dd_date).toISOString().split('T')[0] : '';
          setlatestDDDate(ddformattedDate)
          setCreateIndentDate(ddformattedDate)
          setRowData(responseData);
          setCurrentInvoiceDate(date)
          setStoreOptions(destinationOptions)
          setStoreId(destinationOptions[0])

          const formattedDate = response.data.date
            ? new Date(response.data.date).toISOString().split('T')[0]
            : '';
          setCurrentInvoiceDate(formattedDate);
          await getHighlightedDates()
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    }
    catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      console.error("Error fetching Raised Orders data:", error);
      setBasicTitle("Failed to fetch Raised Orders data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getSkuMasterData()
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  useEffect(() => {
    const getData = async () => {
      if (!rowData.length > 0) {
        await getMainData()
      }
    }
    getData()
  }, []);

  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {
      fileInput.value = "";
    }

    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false)
    setSliderOpen(false)
    setCurrentUploadedDate("")
    resetFormData();
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setUploadedFileData([]);
    setCreateIndentDate(latestDDDate)
    resetFormData();
  };

  const openCreateIndentSlider = () => {
    setSliderType(2);
    setSliderTitle("Create Indent");
    setSliderCl("create-indent-slider");
    setOverlyBlock("show-m");
    setSliderOpen(true);
  };

  const onSaveCreateIndent = async (e) => {
    e.preventDefault();
    
    if (!createIndentDate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select a date");
      return;
    }

    try {
      setIsCreatingIndent(true);
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post("indentation/onTriggerCreateIndent", {
        date: createIndentDate,
      });

      const pyResponse = response?.data?.pyResponse;

      if (pyResponse?.status === "Success") {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(pyResponse?.data?.message);
        setSliderOpen(false);
        setOverlyBlock("show-n");
        setCreateIndentDate(latestDDDate);

        await getMainData();

        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Create Indent",
          status: pyResponse?.data?.status || pyResponse?.status,
          path: window.location.pathname
        });
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(pyResponse?.data?.message || pyResponse?.message);
        setCreateIndentDate("");

        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Create Indent",
          status: pyResponse?.data?.status || pyResponse?.status,
          path: window.location.pathname
        });
      }
    } catch (error) {
      console.error("Error triggering indent:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("error");
      setBasicTitle(
        error?.response?.data?.message || 
        error?.message || 
        "Failed to Trigger Raise Indents"
      );
    } finally {
      setIsCreatingIndent(false);
    }
  };

  const getFiltersData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = { date: currentinvoiceDate, destination_store_id: storeId?.value };
    try {
      const response = await redirectURL.post(
        "indentation/getIndentationCreationsDataBYFilters",
        params
      );
      const data = response.data.data
      setRowData(data)
      setLoadshow("show-n");
      setOverlayBlock("show-n");

    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Error Failed to get Indentation Data");
    }
  };

  const setFilters = async () => {
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    await getFiltersData()
    setOverlayBlock("show-n")
    setLoadshow("show-n")
  }

  const handleDataUpload = async () => {
    const params = {     
      masterData: uploadedFileData, 
      date : currentinvoiceDate
    };

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post("indentation/bulkEditData", params);

      if (response.data.status === "success") {
        await getMainData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Indent Stock Bulk Edit Successful");
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Bulk Edit Failed");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to upload data";
      setShow(true);
      setBasicType("info");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const onClickUploadFileData = (event) => {
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Bulk Edit Data");
    setOverlyBlock("show-m");
  };
  
  const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }

    handleDataUpload(uploadedFileData);
  };

  const downloadExcelTemplate = async () => {
    try {
      const response = await fetch(bulkEditCsv);
      const csvText = await response.text();
      const rows = csvText
        .trim()
        .split("\n")
        .map(line => line.split(","));

      const ws = utils.aoa_to_sheet(rows);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Sheet1");

      writeFile(wb, "sample_bulk_edit_data.xlsx");
    } catch (error) {
      console.error("Error downloading or parsing CSV:", error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value);
    const filename = file.name;
    setFilename(filename);

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      function toSnakeCase(str) {
        return str
          .trim()
          .replace(/\s+/g, "_")
          .replace(/[A-Z]/g, (letter) => letter.toLowerCase())
          .replace(/[^a-z0-9_]/g, "");
      }

      const keyMappings = {
        final_indent_stock: "final_indent_quantity",
      };

      const result = parsedData.map((item) => {
        const newItem = {};
        for (const key in item) {
          const snakeKey = toSnakeCase(key);
          const mappedKey = keyMappings[snakeKey] || snakeKey;
          newItem[mappedKey] = item[key];
        }
        return newItem;
      });

      setUploadedFileData(result);
    };

    reader.readAsArrayBuffer(file);
  };

  const onCellClicked = (params) => {
    if (params.colDef.field === "multi_select") {
      params.node.setSelected(!params.node.isSelected());
    }
  };

  const onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRows(selectedRows)
  };

  const downloadSelectedRows = () => {
    const filteredData = selectedRows.map(row => ({
      "Sku Code": row.sku_code,
      "Destination Store Id": row.destination_store_id,        
      "Final Indent Stock": row.final_indent_quantity,
      "New Indent Stock" : ""
    }));

    const ws = utils.json_to_sheet(filteredData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Active SKUs");
    writeFile(wb, "active_skus.xlsx");
    
    gridRef.current.api.deselectAll();
    setSelectedRows([]);
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row p-0" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <form className="col-sm-12 p-0 m-0 mt-2 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-12 row ">
              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Indent Created Date :
                </label>
                <DatePicker
                  selected={currentinvoiceDate ? new Date(currentinvoiceDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const formattedDate = date.toISOString().split('T')[0];
                      setPrevDate(currentinvoiceDate);
                      setCurrentInvoiceDate(formattedDate);
                    } else {
                      setPrevDate(currentinvoiceDate);
                      setCurrentInvoiceDate("");
                    }
                  }}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select date"
                  className="form-control"
                  highlightDates={highlightedDates}
                  style={{ 
                    padding: "7px", 
                    borderRadius: "5px", 
                    border: "1px solid #d9d9d9", 
                    width: "100%", 
                    marginBottom: "15px", 
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                />
              </div>

              <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Destination Store ID:
                </label>
                <Select
                  id="storeId"
                  value={storeId}
                  onChange={(selectedOption) => { setPrevStoreId(storeId); setStoreId(selectedOption) }}
                  options={storeOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={(e) => { e.preventDefault(); setFilters() }}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}>Apply</button>
                <button
                  onClick={(e) => { e.preventDefault(); getMainData() }}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}>Reset</button>
              </div>
              <div className="mt-4" style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                {/* DOWNLOAD BUTTON - EXACTLY LIKE WAREHOUSE PATTERN */}
                <button
                  type="button"
                  onClick={downloadExcel}
                  disabled={isDownloading || rowData.length === 0}
                  style={{
                    backgroundColor: "#fff",
                    color: "#333",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "0px 20px",
                    height: "39px",
                    cursor: (isDownloading || rowData.length === 0) ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    transition: "all 0.2s ease-in-out",
                    marginRight: "10px",
                    opacity: (isDownloading || rowData.length === 0) ? 0.6 : 1
                  }}
                  onMouseOver={(e) => {
                    if (!isDownloading) {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isDownloading) {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }
                  }}
                >
                  <Download size={18} />
                  <span style={{ marginLeft: "7px" }}>
                    Darkstore Indents Data
                  </span>
                </button>

                <button
                  type="button"
                  onClick={openCreateIndentSlider}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    height: "38px",
                    padding: "0px 20px",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    transition: "all 0.2s ease-in-out",
                    marginRight: "0px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <span style={{ marginLeft: "5px" }}>Raise Indents</span>
                </button>
              </div>
            </div>
          </form>

          <div className="col-sm-12 " style={{background:"#F8F8F8", padding: "10px 20px", borderRadius: "10px" }}>
            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", marginBottom: "5px"}} >
              <button 
                onClick={downloadSelectedRows}
                type="button"
                style={{
                  height: "38px",
                  backgroundColor: selectedRows.length === 0 ? "#eae5e5" : "#fff",
                  color: "#333",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  cursor: selectedRows.length === 0 ? "not-allowed" : "pointer", 
                  display: "flex",
                  padding: "8px 20px",
                  alignItems: "center",
                  transition: "all 0.2s ease-in-out",
                  marginRight: "7px",
                  boxShadow: selectedRows.length === 0 ? "none" : undefined, 
                }}
                onMouseOver={(e) => {
                  if (selectedRows.length > 0) { 
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                  }
                }}
                onMouseOut={(e) => {
                  if (selectedRows.length > 0) {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }
                }}
                disabled={selectedRows.length === 0}
              >
                <i className="fa fa-download" style={{ marginRight: "8px", color: "#555" }} />
                Selected Skus
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  onClickUploadFileData()
                }}
                type="button"
                style={{
                  height: "38px",
                  backgroundColor: "#93385D",
                  color: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  cursor: "pointer",
                  display: "flex",
                  padding: "8px 20px",
                  alignItems: "center",
                  transition: "all 0.2s ease-in-out",
                  marginRight: "0px",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <i className="fa fa-upload" style={{ marginRight: "8px", color: "#fff" }} />
                Bulk Edit
              </button>
            </div>
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={rowData.length}
                enableRangeSelection={true}
                rowSelection="multiple"   
                suppressRowClickSelection={true}            
                onCellClicked={onCellClicked} 
                onSelectionChanged={onSelectionChanged}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Batch Data */}
      <Modal
        open={isBatchModalOpen}
        onClose={() => setBatchModalOpen(false)}
        center
        classNames={{
          modal: 'batch-modal',
          overlay: 'batch-modal-overlay',
        }}
        styles={{
          modal: {
            borderRadius: '12px',
            padding: '24px',
            width: '70%',
            maxWidth: '1000px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
            maxHeight: '80vh',
            overflowY: 'auto'
          }
        }}
      >
        <div style={{ padding: '10px' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: '20px',
            borderBottom: '2px solid #93385D',
            paddingBottom: '15px'
          }}>
            <h3 style={{ color: '#93385D', fontSize: '20px', fontWeight: '600', margin: 0 }}>
              Batch Stock Details
            </h3>
            <button 
              onClick={() => setBatchModalOpen(false)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666',
                padding: '0 8px',
                borderRadius: '4px'
              }}
            >
              
            </button>
          </div>

          {selectedSkuInfo && (
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '20px',
              border: '1px solid #e9ecef'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px' }}>
                <div style={{gap:"none",margin:"0"}}>
                  <span style={{ fontSize: '12px', color: '#6c757d' }}>SKU Code</span>
                  <p style={{ margin: '4px 0 0', fontWeight: '600', color: '#495057' }}>{selectedSkuInfo.sku_code}</p>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d' }}>SKU Name</span>
                  <p style={{ margin: '4px 0 0', fontWeight: '500', color: '#495057' }}>{selectedSkuInfo.sku_name}</p>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d' }}>Store</span>
                  <p style={{ margin: '4px 0 0', fontWeight: '500', color: '#495057' }}>
                    {selectedSkuInfo.store_id} - {selectedSkuInfo.store_name}
                  </p>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d' }}>Source Name</span>
                  <p style={{ margin: '4px 0 0', fontWeight: '500', color: '#495057' }}>
                    {selectedSkuInfo.source_id} - {selectedSkuInfo.source_name}
                  </p>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d' }}>Final Indent Stock</span>
                  <p style={{ margin: '4px 0 0', fontWeight: '700', color: '#93385D' }}>{selectedSkuInfo.total_stock}</p>
                </div>
              </div>
            </div>
          )}

          <div style={{ height: '400px', width: '100%' }}>
            <div className="ag-theme-alpine" style={{ height: '100%', width: '100%' }}>
              <AgGridReact
                ref={batchGridRef}
                rowData={batchData}
                columnDefs={batchColumnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={rowData.length}
                enableRangeSelection={true}
                rowSelection="multiple"   
                suppressRowClickSelection={true}            
                onCellClicked={onCellClicked} 
                onSelectionChanged={onSelectionChanged}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>

          <div style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'flex-end',
            borderTop: '1px solid #dee2e6',
            paddingTop: '20px'
          }}>
            <button
              onClick={() => setBatchModalOpen(false)}
              style={{
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                padding: '8px 24px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#5a6268'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#6c757d'}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>

      {/* Slider for Edit Final Indent Quantity */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={(e) => { e.preventDefault(); onClickingFileSubmit() }}
            >
              <input
                className="mt-3"
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
                required
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn btn-success"
                  style={{
                    color: "#fff",
                    fontSize: "0.8rem",
                    backgroundColor: "#93385D"
                  }}
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        )}
  
        {sliderType === 2 && (
          <div style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding: 5 }}>
            <form style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }} onSubmit={onSaveCreateIndent}>
              <div className="mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label htmlFor="createIndentDate" style={{ fontSize: "13px", fontWeight: "400", cursor: "pointer" }}>
                  Date :
                </label>
                <input
                  type="date"
                  id="createIndentDate"
                  value={createIndentDate}
                  min="2025-09-01"
                  max={latestDDDate}
                  onChange={(e) => setCreateIndentDate(e.target.value)}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() => document.getElementById("createIndentDate").showPicker?.()}
                  required
                />
              </div>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  type="submit"
                  disabled={isCreatingIndent}
                >
                  <span style={{ marginLeft: "5px" }}>{isCreatingIndent ? "Getting Data..." : "Raise Indents"}</span>
                </button>
              </div>
            </form>
          </div>
        )}

        {sliderType === 3 && editingRow && (
          <form style={{ padding: "20px" }}
            onSubmit={(e) => {
              e.preventDefault()
              e.stopPropagation()
              handleSaveEdit(e);
            }}
          >
            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "600" }}>SKU Code:</label>
              <p style={{ margin: "5px 0", fontSize: "14px", backgroundColor: "#f9f9f9", padding: "8px", borderRadius: "4px" }}>
                {editingRow.sku_code}
              </p>
            </div>

            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "600" }}>SKU Name:</label>
              <p style={{ margin: "5px 0", fontSize: "14px", backgroundColor: "#f9f9f9", padding: "8px", borderRadius: "4px" }}>
                {editingRow.sku_name}
              </p>
            </div>

            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "600" }}>Store ID:</label>
              <p style={{ margin: "5px 0", fontSize: "14px", backgroundColor: "#f9f9f9", padding: "8px", borderRadius: "4px" }}>
                {editingRow.destination_store_id}
              </p>
            </div>

            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "600" }}>Old Final Indent Quantity:</label>
              <p style={{ margin: "5px 0", fontSize: "14px", backgroundColor: "#fff3cd", padding: "8px", borderRadius: "4px", fontWeight: "bold" }}>
                {editingRow.old_final_indent_quantity || editingRow.final_indent_quantity || "NA"}
              </p>
            </div>

            <div className="form-group">
              <label htmlFor="final_indent_quantity" style={{ fontSize: "13px", fontWeight: "600" }}>
                Final Indent Quantity: <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="number"
                className="form-control"
                id="final_indent_quantity"
                name="final_indent_quantity"
                value={editFormData.final_indent_quantity || ""}
                onChange={(e) => setEditFormData({
                  ...editFormData,
                  final_indent_quantity: e.target.value === "" ? "" : parseInt(e.target.value)
                })}
                placeholder="Enter final indent quantity"
                min="0"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "0.9rem"
                }}
                required
              />
            </div>

            <div style={addButtonContainerStyle}>
              <button
                type="submit"
                id="sample-download-button"
                style={addButtonStyle}
              >
                Update
              </button>
            </div>
          </form>
        )}
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily: "sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: "12px"
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? 'normal' : 'normal',
  })
}

export default IndentationCreation;